
import rowTranslations from './Row.translations'
import Row from './Row.vue'
import { groupBy } from './Table.helpers'
import translations from './Table.translations'

export default {
  components: {
    Row,
  },

  props: {
    columns: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },

  computed: {
    translations: () => translations,
    rowData() {
      const columnsData = [
        ...this.enrichDataWithId(this.columns[0]),
        ...this.enrichDataWithId(this.columns[1]),
      ]

      const rowDataByLabel = groupBy(columnsData, 'label')

      return rowDataByLabel
    },
    tableTitle() {
      return Object.values(rowTranslations).find(({ id }) => id === this.name)
    },
    isBattery() {
      return this.name === 'product_comparison_characteristics_battery'
    },
  },

  methods: {
    enrichDataWithId(column) {
      // Create an array of data containing the product
      const { attributes, productId } = column
      const dataWithId = attributes.map((dataItem) => {
        const dataItemWithId = { ...dataItem, productId }

        return dataItemWithId
      })

      return dataWithId
    },
  },
}
